import React, { useEffect, useState, useRef } from "react";
import Constants from "../services/constant";
import { getData } from "../services/http.service";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { deleteData } from "../services/http.service";
import { Toast } from "primereact/toast";

const Reviews = () => {
    useEffect(() => {
        getAllReviews();
    }, []);

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    const getAllReviews = () => {
        setLoading(true);
        getData(Constants.END_POINT.GET_ALL_BUSINESS_REVIEWS)
            .then((res) => {
                setLoading(false);
                setData(res?.data);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });
    };

    //  delete table data function
    const deleteTableData = (id) => {
        deleteData(Constants.END_POINT.DELETE_BUSINESS_REVIEWS + id)
            .then((res) => {
                if (res.success) {
                    toast.current.show({ severity: "info", summary: "Confirmed", detail: "Review has been Deleted Succesfully", life: 3000 });
                    getAllReviews(); // Refresh data after deletion
                }
            })
            .catch((err) => console.log(err));
    };

    const toast = useRef(null);

    const reject = () => {
        toast.current.show({ severity: "warn", summary: "Rejected", detail: "You have rejected", life: 3000 });
    };

    //  Action  Table btn  EDit and Delete functions
    const actionTemplate = (rowData) => {
        return (
            <div className="d-flex">
                ``
                <Button type="button" className="p-button-danger  m-1 " onClick={() => deletepopup(rowData._id, "top-right")}>
                    Delete
                </Button>
            </div>
        );
    };

    const deletepopup = (id, position) => {
        confirmDialog({
            message: "Do you want to delete this Safety Rule?",
            icon: "pi pi-info-circle",
            header: "Delete Confirmation",
            acceptClassName: "p-button-danger",
            position,
            accept: () => deleteTableData(id),
            reject,
        });
    };

    return (
        <div className="grid table-demo">
            <div className="col-12">
                <Toast ref={toast} />
                <div className="card">
                    <div className="flex justify-content-between mb-4">
                        <h5>Reviews</h5>
                    </div>

                    <DataTable value={data} responsiveLayout="scroll" paginator rows={8} loading={loading}>
                        <Column field="businessName" header="Business Name" style={{ width: "35%" }} />
                        <Column field="review" header="Review" style={{ width: "35%" }}></Column>
                        <Column field="rating" header="Rating" style={{ width: "35%" }}></Column>
                        <Column header="Action" body={actionTemplate} style={{ width: "10%" }}></Column>
                    </DataTable>
                </div>
            </div>
        </div>
    );
};

export default Reviews;
